export default __webpack_public_path__ + "static/media/eva_headshot.71c826cc.png";